import React from 'react';
import { Col, Row, FormGroup, Label, Input } from 'reactstrap';
import { FormikProps } from 'formik';
import { ShopFormValues } from 'components/Types/Tenant/shop.type';

interface Props {
  formik: FormikProps<ShopFormValues>;
}

const ContactLocationTab: React.FC<Props> = ({ formik }) => {
  return (
    <Row>
      <Col md={6}>
        <FormGroup>
          <Label>Contact Number</Label>
          <Input
            type="text"
            name="contactNumber"
            value={formik.values.contactNumber}
            onChange={formik.handleChange}
            invalid={!!(formik.touched.contactNumber && formik.errors.contactNumber)}
          />
          {formik.touched.contactNumber && formik.errors.contactNumber && (
            <div className="invalid-feedback">{formik.errors.contactNumber}</div>
          )}
        </FormGroup>
      </Col>
      <Col md={6}>
        <FormGroup>
          <Label>Street Address</Label>
          <Input
            type="text"
            name="streetAddress"
            value={formik.values.streetAddress}
            onChange={formik.handleChange}
            invalid={!!(formik.touched.streetAddress && formik.errors.streetAddress)}
          />
          {formik.touched.streetAddress && formik.errors.streetAddress && (
            <div className="invalid-feedback">{formik.errors.streetAddress}</div>
          )}
        </FormGroup>
      </Col>
      <Col md={6}>
        <FormGroup>
          <Label>City</Label>
          <Input
            type="text"
            name="city"
            value={formik.values.city}
            onChange={formik.handleChange}
            invalid={!!(formik.touched.city && formik.errors.city)}
          />
          {formik.touched.city && formik.errors.city && (
            <div className="invalid-feedback">{formik.errors.city}</div>
          )}
        </FormGroup>
      </Col>
      <Col md={6}>
        <FormGroup>
          <Label>State</Label>
          <Input
            type="text"
            name="state"
            value={formik.values.state}
            onChange={formik.handleChange}
            invalid={!!(formik.touched.state && formik.errors.state)}
          />
          {formik.touched.state && formik.errors.state && (
            <div className="invalid-feedback">{formik.errors.state}</div>
          )}
        </FormGroup>
      </Col>
      <Col md={6}>
        <FormGroup>
          <Label>Country</Label>
          <Input
            type="text"
            name="country"
            value={formik.values.country}
            onChange={formik.handleChange}
            invalid={!!(formik.touched.country && formik.errors.country)}
          />
          {formik.touched.country && formik.errors.country && (
            <div className="invalid-feedback">{formik.errors.country}</div>
          )}
        </FormGroup>
      </Col>
      <Col md={6}>
        <FormGroup>
          <Label>Zip Code</Label>
          <Input
            type="text"
            name="zipCode"
            value={formik.values.zipCode}
            onChange={formik.handleChange}
            invalid={!!(formik.touched.zipCode && formik.errors.zipCode)}
          />
          {formik.touched.zipCode && formik.errors.zipCode && (
            <div className="invalid-feedback">{formik.errors.zipCode}</div>
          )}
        </FormGroup>
      </Col>
    </Row>
  );
};

export default ContactLocationTab;
